import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth0postPostScreenTruthAppsResponseSchema = jsonObject
export type tcpscreentruth0postPostScreenTruthAppsResponse = z.infer<typeof tcpscreentruth0postPostScreenTruthAppsResponseSchema>
export const tcpscreentruth0postPostScreenTruthAppsAppBindingsResponseSchema = jsonObject
export type tcpscreentruth0postPostScreenTruthAppsAppBindingsResponse = z.infer<typeof tcpscreentruth0postPostScreenTruthAppsAppBindingsResponseSchema>
